import React, { useEffect, useState } from 'react';
import Table from '../../../component/Table/Table';
import { axiosInstance as axios } from '../../../axios/axios';
import { useSelector, useDispatch } from 'react-redux';
import * as Action from '../../../store/actions';
import Icon from '../../../component/Icon';
import * as actionCreators from '../../../store/actionCreators/index';
import TableActionButton from '../../../component/Table/TableActionButton/TableActionButton';

const Reservations = () => {
  const [loading, setLoading] = useState(false);
  const state = useSelector((state) => state);
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const [totalPage, setTotalPage] = useState(1);
  const [productLimit, setProductLimit] = useState(1);
  useEffect(() => {
    (async () => {
      try {
        dispatch({ type: Action.GET_ALLRESERVATIONS, payload: [] });

        const res = await axios.get(`/api/reservations?page=${page}`, {
          headers: { authorization: `Bearer ${state.auth.token}` },
        });

        setProductLimit(res.data.meta.per_page);
        setTotalPage(res.data.meta.total);
        dispatch({ type: Action.GET_ALLRESERVATIONS, payload: res.data.data });
      } catch (err) {
        console.log(err.message);
        dispatch({ type: Action.GET_ALLRESERVATIONS, payload: [] });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const deleteReservation = (data) => {
    dispatch(
      actionCreators.deleteReservation(data.id, setLoading, state.auth.token)
    );
  };

  const tableHead = [
    'S.N',
    'Username',
    'No. of people',
    'Date',
    'Time',
    'Action',
  ];
  let data;
  if (
    state.reservation.backend.reservationList &&
    state.reservation.backend.reservationList.length !== 0
  ) {
    data = state.reservation.backend.reservationList.map((el, id) => {
      return [
        `# ${(page - 1) * productLimit + id + 1}`,
        `${el.user.firstname}  ${el.user.lastname}   `,

        el.people,
        el.date,
        el.time,

        <TableActionButton
          clickedDelete={() => deleteReservation(el)}
          display={['delete']}
        />,
      ];
    });
  }

  return (
    <div>
      <h2 className='text-greySecondary mb-8 ml-12 font-[500] text-3xl'>
        Reservation
      </h2>
      <Table
        tableHead={tableHead}
        tableData={data}
        page={page}
        setPage={setPage}
        totalPage={totalPage}
        productLimit={productLimit}
      />
    </div>
  );
};

export default Reservations;
